// extracted by mini-css-extract-plugin
module.exports = {"Foliage":"Foliage_Foliage__2lOsO"};